"use strict";
// Browser-safe subpath. Import only this when bundling for the web —
// `./index` pulls in `GatewayServer`, which in turn statically imports
// `node:net`, `node:http`, and `ws`, none of which resolve in a browser.
//
// The full index re-exports this, so Node consumers can keep using
// `import { GatewayClient } from "@emdzej/ediabasx-interfaces"` without
// caring about the subpath.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayClient = void 0;
var gateway_client_1 = require("./gateway-client");
Object.defineProperty(exports, "GatewayClient", { enumerable: true, get: function () { return gateway_client_1.GatewayClient; } });
//# sourceMappingURL=client.js.map